import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import axios from "axios";
import { composeWithDevTools } from "redux-devtools-extension";
import { ReduxState } from "helpers/helper";
import { AuthorizationToken } from "helpers/AuthorizationToken";
import { WAREHOUSE_URL, INITIAL_STATE } from "constants/AppConstants";
import reducer from "../reducers";
import { setCurrentUser } from "../actions/authActions";

const store = createStore<ReduxState, any, {}, {}>(
  reducer,
  INITIAL_STATE,
  composeWithDevTools(applyMiddleware(thunk))
);

if (localStorage.jwtToken && localStorage.currentUser) {
  AuthorizationToken.set(localStorage.jwtToken);
  try {
    let user = JSON.parse(localStorage.currentUser);
    store.dispatch(setCurrentUser(user));
    if (user.divisions === undefined) {
      axios.get(WAREHOUSE_URL).then(res => {
        user.divisions = res.data.results;
        store.dispatch(setCurrentUser(user));
      });
    }
  } catch {}
}
// @ts-ignore
window.store = store;

export default store;
